/* stepId comes from the formulary url as the `title` query param */
/* eslint-disable-next-line */
export const getCurrentStep = (steps, stepId) =>
  steps.find((step) => step.stepId === stepId)
